import SharingsSectionDefaultBackground from "./SharingsSectionDefaultBackground.png";
import SharingsSectionDefaultHeader from "./SharingsSectionDefaultHeader.png";

export const IMAGES = {
  SharingsSectionDefaultBackground,
  SharingsSectionDefaultHeader
};
